import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const doctorsRouter = {
  path: '/doctors',
  component: Layout,
  name: 'doctors',
  redirect: 'doctors',
  children: [
    {
      path: 'doctors',
      component: () => import('@/views/doctors/index'),
      name: 'doctors.index',
      meta: { title: i18n.t(`message.doctors`)}
    },
  ]
}

export default doctorsRouter